/* eslint-disable max-statements */
/* eslint-disable max-params */

export const isTimeSlotAvailable = (appointmentDate, appointmentTime, slots, selectedBranch) => {
    let isInvalidAppointmentDate = true;
    let isInvalidAppointmentTime = true;
    const selectedBranchSlots = slots && selectedBranch && slots[selectedBranch] && slots[selectedBranch].date_slot;

    if (selectedBranchSlots) {
        const dateObj = selectedBranchSlots.filter(elem => elem.date === appointmentDate);

        if (dateObj && dateObj.length > 0) {
            const slotObj = dateObj[0].time.filter(elem => elem.value === appointmentTime);
            isInvalidAppointmentDate = false;

            if (slotObj && slotObj.length > 0) {
                isInvalidAppointmentTime = false;
            }
        }
    }

    return { isInvalidAppointmentDate, isInvalidAppointmentTime };
};

export const isValidDateAndTime  =  (appointmentDate, appointmentTime, slots, selectedBranch, isRevamped = false) => {
    let isInvalidAppointmentDate;
    let isInvalidAppointmentTime;
    const availableDateSlots = [];
    slots[selectedBranch].date_slot.map(date =>  availableDateSlots.push(date.date));
    if (availableDateSlots.includes(appointmentDate)) {
        if (new Date(appointmentDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
            const [hour, min, seconds] = appointmentTime.split(":");
            if (new Date(appointmentDate).setHours(hour, min, seconds) < new Date().getTime()) {
                isInvalidAppointmentDate = false;
                isInvalidAppointmentTime = true;
            } else {
                isInvalidAppointmentDate = false;
                isInvalidAppointmentTime = false;
            }
        } else if (isRevamped) {
            const status = isTimeSlotAvailable(appointmentDate, appointmentTime, slots, selectedBranch);

            isInvalidAppointmentDate = status.isInvalidAppointmentDate;
            isInvalidAppointmentTime = status.isInvalidAppointmentTime;
        } else {
            isInvalidAppointmentDate = false;
            isInvalidAppointmentTime = false;
        }
    } else {
        isInvalidAppointmentDate = true;
        isInvalidAppointmentTime = true;
    }
    return { isInvalidAppointmentDate, isInvalidAppointmentTime };
};
